/**
 * sentenceChooChooData.js
 * Cambridge Young Learners (Pre-A1 Starters -> A1 Movers -> A2 Flyers)
 * Sentence syntax chunks for Sentence Choo-Choo (Syntax Rail) arcade game.
 */

export const SENTENCE_CHOO_CHOO_ROUNDS = [
  {
    id: 'round_1',
    level: 'Starters',
    fullSentence: 'The brown dog is barking loudly.',
    chunks: ['The brown dog', 'is barking', 'loudly.'],
    distractor: 'swimming fast',
  },
  {
    id: 'round_2',
    level: 'Starters',
    fullSentence: 'Lucy rides her blue bicycle to school.',
    chunks: ['Lucy rides', 'her blue bicycle', 'to school.'],
    distractor: 'flying high',
  },
  {
    id: 'round_3',
    level: 'Movers',
    fullSentence: 'Jake opened his lunch box at noon.',
    chunks: ['Jake opened', 'his lunch box', 'at noon.'],
    distractor: 'reading books',
  },
  {
    id: 'round_4',
    level: 'Movers',
    fullSentence: 'Three monkeys climbed up the tall green tree.',
    chunks: ['Three monkeys', 'climbed up', 'the tall green tree.'],
    distractor: 'baking cakes',
  },
  {
    id: 'round_5',
    level: 'Movers',
    fullSentence: 'They are playing football in the school playground.',
    chunks: ['They are playing', 'football happily', 'in the school playground.'],
    distractor: 'under water',
  },
  {
    id: 'round_6',
    level: 'Flyers',
    fullSentence: 'Tom carefully walked down the corridor after class.',
    chunks: ['Tom carefully walked', 'down the corridor', 'after science class.'],
    distractor: 'into outer space',
  },
  {
    id: 'round_7',
    level: 'Flyers',
    fullSentence: 'The friendly doctor helped the injured boy yesterday.',
    chunks: ['The friendly doctor', 'helped the injured boy', 'yesterday morning.'],
    distractor: 'playing guitar',
  },
  {
    id: 'round_8',
    level: 'Flyers',
    fullSentence: 'Water on the floor reduces friction and causes slipping.',
    chunks: ['Water on the floor', 'reduces surface friction', 'and causes slipping.'],
    distractor: 'drinking milk',
  },
];
